import {
  BrowserPersistence 
} from "@/util"

const storage = new BrowserPersistence()

// If the root template supplies the backend URL at runtime, use it directly
const {
  documentElement: htmlElement 
} = globalThis.document || {}
const {
  imageOptimizingOrigin 
} = htmlElement ? htmlElement.dataset : {}
const alreadyOptimized = imageOptimizingOrigin === "backend"

// Protect against potential falsy values for `mediaBackend`.
const storeCode =
    storage.getItem("store_view_code") ||
    process.env.NEXT_PUBLIC_STORE_VIEW_CODE
const storeSecureBaseMediaUrl = {}

// Fallback to global secure_base_media_url set at build time
JSON.parse(process.env.NEXT_PUBLIC_AVAILABLE_STORE_VIEWS).forEach((store) => {
  storeSecureBaseMediaUrl[store.store_code] = store.secure_base_media_url
})

let mediaBackend =
    storage.getItem("store_view_secure_base_media_url") ||
    storeSecureBaseMediaUrl[storeCode]

if (!mediaBackend) {
  console.warn("A media backend URL should be defined in your config.")
  mediaBackend = "https://backend.test/media/"
}

// Tests if a URL begins with `http:` or `https:` or `data:`
const absoluteUrl = /^(data|http|https)?:/i

// Simple path joiner that guarantees one and only one slash between segments
const joinUrls = (base, url) => (base.endsWith("/") ? base.slice(0, -1) : base) +
    "/" +
    (url?.startsWith("/") ? url.slice(1) : url)

const mediaBases = new Map()
  .set("image-product", "catalog/product/")
  .set("image-category", "catalog/category/")
  .set("image-swatch", "attribute/swatch/")

const getFileType = (url) => {
  const fileName = url.pathname.split("/").reverse()[0]
  const fileType = fileName.split(".").reverse()[0]

  return fileType
}

const makeOptimizedUrl = (path, {
  type, ...opts 
} = {}) => {
  // Immediate return if there's no image optimization to attempt
  if (!type || !type.startsWith("image-")) {
    return path
  }

  const {
    origin 
  } = globalThis.location || {}
  const isAbsolute = absoluteUrl.test(path)
  const magentoBackendURL = process.env.NEXT_PUBLIC_MAGENTO_BACKEND_URL
  let baseURL = new URL(path, mediaBackend)

  // If URL is relative and has a supported type, prepend media base onto path
  if (!isAbsolute && mediaBases.has(type)) {
    const mediaBase = mediaBases.get(type)

    if (!baseURL.pathname.includes(mediaBase)) {
      baseURL = new URL(joinUrls(mediaBase, path), mediaBackend)
    }
  }

  if (baseURL.href.startsWith(magentoBackendURL) && !alreadyOptimized) {
    // Replace URL base so optimization middleware can handle request
    baseURL = new URL(baseURL.href.slice(magentoBackendURL.length), origin)
  }

  // Append image optimization parameters
  const params = new URLSearchParams(baseURL.search)

  params.set("auto", "webp") // Use the webp format if available

  const imageFileType = getFileType(baseURL)

  if (imageFileType === "png") {
    params.set("format", "png") // use png if webp is not available
  } else {
    params.set("format", "pjpg") // Use progressive JPG if webp is not available
  }

  Object.entries(opts).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      params.set(key, value)
    }
  })
  baseURL.search = params.toString()

  if (baseURL.origin === origin) {
    return baseURL.href.slice(baseURL.origin.length)
  }

  return baseURL.href
}

export default makeOptimizedUrl
